import { createSelector } from '@reduxjs/toolkit'
import { AS_USER, AS_USER_EMAIL, AS_USER_DEFAULT_NAME } from '~/lib/constants'

// Selectors
export const selectAuth = s => s.auth

/*
 * Replace only the DISPLAYED identity under ?as-user, so a published screenshot never carries a real address. Everything auth actually depends on is left alone: `sub` (persist keys, the user-changed reload check in AuthGuard), roles (elevation is denied separately below), and the token — which never lives on the user object at all.
 *
 * Applied at the selector, not the reducer, so the store keeps the true user and the mask cannot survive into anything that reads auth state directly.
 */
const maskUser = user => {
	if (!user) return user
	return {
		...user,
		email: AS_USER_EMAIL,
		name: AS_USER_DEFAULT_NAME,
		nickname: AS_USER_DEFAULT_NAME,
		picture: undefined,
	}
}

const selectRawUser = s => s.auth?.user

export const selectUser = AS_USER ? createSelector(selectRawUser, maskUser) : selectRawUser

// `?as-user` forces a normal-user view (see constants.js). Both selectors that grant admin elevation short-circuit to false so admin- and template-creator-only UI is hidden — for honest doc screenshots and normal-user debugging. These read the RAW user: masking is about the displayed identity, elevation is denied by the flag itself, and conflating the two would hide the real rule.
export const selectIsAdmin = createSelector(selectRawUser, user => {
	if (AS_USER) return false
	return user?.roles?.includes('admin') || false
})

export const selectIsTemplateCreator = createSelector(selectRawUser, user => {
	if (AS_USER || !user) return false
	return user.roles.includes('template_creator') || user.roles.includes('admin')
})
